<template>
    <div>
        <DCard
            :title="__('tools.invoice_uploads.upload.title')"
            padding
        >
            <DFormRow
                :label="__('tools.invoice_uploads.upload.name')"
                is-required
            >
                <DInput
                    id="pricing-upload-name"
                    v-model="form.name"
                    requried
                    :invalid-feedback="errors.name"
                />
            </DFormRow>
            <div class="file-section">
                <DFormRow
                    :label="__('tools.invoice_uploads.upload.file')"
                    is-required
                    class="pricing-upload-file"
                >
                    <DFileInput
                        id="pricing-upload-file"
                        :custom="true"
                        :multiple="false"
                        :invalid-feedback="errors.file"
                        :file-with-errors="fileWithErrors"
                        @change="addFile"
                        @reset-file-with-errors="resetFileWithErrors"
                    />
                    <p v-if="form.file">
                        {{ form.file.name }}
                    </p>
                </DFormRow>
                <DButton
                    icon="download"
                    :label="__('tools.invoice_uploads.upload.download_csv')"
                    @click="downloadCsv"
                />
            </div>
        </DCard>
        <DCard
            v-if="errors.errorMessage"
            :title="__('tools.invoice_uploads.upload.file_errors')"
            padding
            class="mt-3"
        >
            <DRow
                v-for="(error, index) in errors"
                :key="index"
            >
                <DFormRow
                    v-if="error.length > 0 && index !== 'errorMessage'"
                    :label="`${__('tools.invoice_uploads.upload.messages.row')} ${index}:`"
                >
                    {{ displayError(error) }}
                </DFormRow>
            </DRow>
        </DCard>
    </div>
    <DFormControls
        :dirty="form.isDirty"
        :submit-message="__('tools.invoice_uploads.upload.submit')"
        submit-icon="check"
        :cancel-route="cancelRoute"
        @submit="submitForm"
    />
</template>

<script setup>
import { route } from '~@/Composables/route'
import { useForm } from '@inertiajs/vue3'
import { __ } from '~@/Composables/translation'
import { computed, ref } from 'vue'

defineProps({
    errors: {
        type: Object,
        default: () => {
            return {}
        }
    }
})

const form = useForm({
    name: null,
    file: null,
    inform_customers: true
})

const displayError = (error) => {
    const errors = error.split(', ')
    return errors.map(er => __(`tools.invoice_uploads.upload.messages.${er}`)).join(', ')
}
const downloadCsv = () => {
    const link = document.createElement('a')
    link.href = route('tools.manual-invoice-uploads.download-template')
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
}

const fileWithErrors = ref(false)

function addFile (fileList) {
    form.file = fileList[0]
}

function submitForm () {
    form.post(route('tools.manual-invoice-uploads.file-upload'), {
        onError: () => {
            form.file = null
            fileWithErrors.value = true
        }
    })
}

function resetFileWithErrors () {
    fileWithErrors.value = false
}

const cancelRoute = computed(() => {
    return route('tools.manual-invoice-uploads.index')
})
</script>

<style scoped lang="scss">
    .pricing-upload-file {
        margin-bottom: 5px!important;
    }
    .file-section {
        margin-bottom: 25px;
    }
</style>
